import { Auction, Item } from '@/api';
import { getPoster } from '@/app/utils/item-utils';
import ArtistTitle from '@/components/general/ArtistTitle';
import SmallLogo from '@/components/general/LogoSmall';
import Price from '@/components/general/Price';
import { ResponsiveImage } from '@/components/general/ResponsiveImage';
import If, { Else } from '@/components/util/IF';
import useAuth from '@/contexts/AuthContext';
import useAuction from '@/hooks/useAuction';
import useCart from '@/hooks/useCart';
import useOffers from '@/hooks/useOffers';
import i18next from 'i18next';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import React, { useMemo } from 'react';

type Props = {
    cartItem: Item;
};

const CartAlsoLikeRow = ({ cartItem }: Props) => {
    const { user } = useAuth();
    const item = cartItem as Item;
    const router = useRouter();
    const { addToCart } = useCart();
    const { offerPossible } = useOffers(item, true);
    const { hasAuction, auction } = useAuction(item, undefined, true);
    const hasAuctionFlag = hasAuction && !offerPossible;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { private: isPrivate, images, private_preview_image_url, artists, slug } = item;
    const firstImage = useMemo(() => getPoster(images), [images]);
    const renderPrivateImage = (isPrivate && !user);
    let { name } = item;
    if (isPrivate && !user) {
        name = i18next.t('item-text.private-title');
    }
    return (
        <div className="flex flex-row justify-between gap-[16px]">
            <div className="">
                <If condition={renderPrivateImage && !private_preview_image_url}>
                    <SmallLogo className="cursor-pointer object-cover h-[96px] w-[96px] max-h-[96px] min-w-[96px] block p-12 [&>path]:fill-blue2" />
                    <Else>
                        <ResponsiveImage
                            onClick={() => router.push(`/item/${slug}`)}
                            alt={name}
                            src={renderPrivateImage ? private_preview_image_url : firstImage?.url}
                            imageWidth={96}
                            width={96}
                            height={96}
                            className="cursor-pointer object-cover h-[96px] w-[96px] max-h-[96px] min-w-[96px] block rounded-[8px]" />
                    </Else>
                </If>
            </div>
            <div className="h-auto flex flex-col justify-between w-full">
                <div className="">
                    <h3 className="text-[16px] font-[500] leading-[20px] tracking-[-0.2px] cursor-pointer hidden md:block"><Link href={`/item/${slug}`}>{name}</Link></h3>
                    <If condition={artists.length > 0}>
                        <ArtistTitle artist={artists?.[0]} variant={0} />
                        <Else>
                            <span className="text-[14px] font-[500] mt-[-4px] block">&nbsp;</span>
                        </Else>
                    </If>
                </div>
                <If condition={auction && hasAuctionFlag && auction?.type === Auction.TypeEnum.BuyNow && auction?.status === Auction.StatusEnum.Open && auction?.buy_now_amount && item}>
                    <Price number={auction?.buy_now_amount ?? '0'} />
                </If>

            </div>
            <div className="min-w-[69px] max-w-[69px] text-[16px] font-[500] flex flex-col justify-between items-center">

                <button
                    onClick={() => addToCart(item)}
                    className="border-[1px] border-[#EFF0F0] w-[40px] flex justify-center items-center rounded-full h-[40px] hover:opacity-60">
                    <span className=" text-[34px] font-[200] mt-[-5px] ml-[1px]">+</span>
                </button>
            </div>
        </div>
    );
};

export default CartAlsoLikeRow;
